var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



//////////////////
// WEBPACK FOOTER
// ./~/subscribe-ui-event/~/lodash/_coreJsData.js
// module id = 2588
// module chunks = 0